'use client';
import { useUserInfoAndMenus } from '../../../../../hooks/useUserInfoAndMenus';
import { UnextLogoAndTypeDarkJetblackImage } from '../../../../parts/svgImages/UnextLogoAndTypeImage';
import type { UserInfo } from '../../../../../hooks/useUserInfoAndMenus';
import type { Config } from 'u-next/config';

function extractLogoImage(userInfo: UserInfo): React.ReactNode {
  if (userInfo.isYamadaPF) {
    return (
      <img
        className="block size-full object-contain object-center"
        src="//metac.nxtv.jp/img/wf/logo/yamada.png"
        alt="U-NEXT"
      />
    );
  }

  switch (userInfo.otherFunctionId) {
    case '600':
    case '700':
    case '701':
      return (
        <img
          className="block size-full object-contain object-center"
          src={`//metac.nxtv.jp/img/wf/logo/unext${userInfo.otherFunctionId}.png`}
          alt="U-NEXT"
        />
      );

    default:
      return (
        <UnextLogoAndTypeDarkJetblackImage
          className="absolute inset-y-0 my-auto block w-32"
          alt="U-NEXT"
        />
      );
  }
}

export const SiteLogo: React.FC<{
  options: Config;
}> = ({ options }) => {
  const { userInfo } = useUserInfoAndMenus();
  return (
    <a href={options.VIDEO} className="absolute inset-y-0 left-4 w-40">
      {extractLogoImage(userInfo)}
    </a>
  );
};
